export const EMAIL_QUOTE_TEMPLATE = `<!--[if (mso 16)]>
  <style type="text/css">
    a {
      text-decoration: none;
    }
  </style>
<![endif]-->
<!--[if gte mso 9]>
  <style>
    sup {
      font-size: 100% !important;
    }
  </style>
<![endif]-->
<!--[if gte mso 9]>
  <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG></o:AllowPNG>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
  </xml>
<![endif]-->
<style type="text/css">
  .rollover:hover .rollover-first {
    max-height: 0px !important;
    display: none !important;
  }
  .rollover:hover .rollover-second {
    max-height: none !important;
    display: block !important;
  }
  .rollover span {
    font-size: 0px;
  }
  u + .body img ~ div div {
    display: none;
  }
  #outlook a {
    padding: 0;
  }
  span.MsoHyperlink,
  span.MsoHyperlinkFollowed {
    color: inherit;
    mso-style-priority: 99;
  }
  a.es-button {
    mso-style-priority: 100 !important;
    text-decoration: none !important;
  }
  a[x-apple-data-detectors],
  #MessageViewBody a {
    color: inherit !important;
    text-decoration: none !important;
    font-size: inherit !important;
    font-family: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
  }
  .es-desk-hidden {
    display: none;
    float: left;
    overflow: hidden;
    width: 0;
    max-height: 0;
    line-height: 0;
    mso-hide: all;
  }
  .es-button-border:hover {
    border-color: #3d5ca3 #3d5ca3 #3d5ca3 #3d5ca3 !important;
    background: #ffffff !important;
  }
  .es-button-border:hover a.es-button,
  .es-button-border:hover button.es-button {
    background: #ffffff !important;
  }
  @media only screen and (max-width: 600px) {
    .es-m-p0l {
      padding-left: 0px !important;
    }
    .es-p-default {
    }
    *[class="gmail-fix"] {
      display: none !important;
    }
    p,
    a {
      line-height: 150% !important;
    }
    h1,
    h1 a {
      line-height: 120% !important;
    }
    h2,
    h2 a {
      line-height: 120% !important;
    }
    h3,
    h3 a {
      line-height: 120% !important;
    }
    h4,
    h4 a {
      line-height: 120% !important;
    }
    h5,
    h5 a {
      line-height: 120% !important;
    }
    h6,
    h6 a {
      line-height: 120% !important;
    }
    .es-header-body p {
    }
    .es-content-body p {
    }
    .es-footer-body p {
    }
    .es-infoblock p {
    }
    h1 {
      font-size: 20px !important;
      text-align: center;
    }
    h2 {
      font-size: 16px !important;
      text-align: left;
    }
    h3 {
      font-size: 20px !important;
      text-align: center;
    }
    h4 {
      font-size: 24px !important;
      text-align: left;
    }
    h5 {
      font-size: 20px !important;
      text-align: left;
    }
    h6 {
      font-size: 16px !important;
      text-align: left;
    }
    .es-header-body h1 a,
    .es-content-body h1 a,
    .es-footer-body h1 a {
      font-size: 20px !important;
    }
    .es-header-body h2 a,
    .es-content-body h2 a,
    .es-footer-body h2 a {
      font-size: 16px !important;
    }
    .es-header-body h3 a,
    .es-content-body h3 a,
    .es-footer-body h3 a {
      font-size: 20px !important;
    }
    .es-header-body h4 a,
    .es-content-body h4 a,
    .es-footer-body h4 a {
      font-size: 24px !important;
    }
    .es-header-body h5 a,
    .es-content-body h5 a,
    .es-footer-body h5 a {
      font-size: 20px !important;
    }
    .es-header-body h6 a,
    .es-content-body h6 a,
    .es-footer-body h6 a {
      font-size: 16px !important;
    }
    .es-menu td a {
      font-size: 14px !important;
    }
    .es-header-body p,
    .es-header-body a {
      font-size: 10px !important;
    }
    .es-content-body p,
    .es-content-body a {
      font-size: 16px !important;
    }
    .es-footer-body p,
    .es-footer-body a {
      font-size: 12px !important;
    }
    .es-infoblock p,
    .es-infoblock a {
      font-size: 12px !important;
    }
    .es-m-txt-c,
    .es-m-txt-c h1,
    .es-m-txt-c h2,
    .es-m-txt-c h3,
    .es-m-txt-c h4,
    .es-m-txt-c h5,
    .es-m-txt-c h6 {
      text-align: center !important;
    }
    .es-m-txt-r,
    .es-m-txt-r h1,
    .es-m-txt-r h2,
    .es-m-txt-r h3,
    .es-m-txt-r h4,
    .es-m-txt-r h5,
    .es-m-txt-r h6 {
      text-align: right !important;
    }
    .es-m-txt-j,
    .es-m-txt-j h1,
    .es-m-txt-j h2,
    .es-m-txt-j h3,
    .es-m-txt-j h4,
    .es-m-txt-j h5,
    .es-m-txt-j h6 {
      text-align: justify !important;
    }
    .es-m-txt-l,
    .es-m-txt-l h1,
    .es-m-txt-l h2,
    .es-m-txt-l h3,
    .es-m-txt-l h4,
    .es-m-txt-l h5,
    .es-m-txt-l h6 {
      text-align: left !important;
    }
    .es-m-txt-r img,
    .es-m-txt-c img,
    .es-m-txt-l img {
      display: inline !important;
    }
    .es-m-txt-r .rollover:hover .rollover-second,
    .es-m-txt-c .rollover:hover .rollover-second,
    .es-m-txt-l .rollover:hover .rollover-second {
      display: inline !important;
    }
    .es-m-txt-r .rollover span,
    .es-m-txt-c .rollover span,
    .es-m-txt-l .rollover span {
      line-height: 0 !important;
      font-size: 0 !important;
    }
    .es-spacer {
      display: inline-table;
    }
    a.es-button,
    button.es-button {
      font-size: 14px !important;
      padding: 10px 20px 10px 20px !important;
      line-height: 120% !important;
    }
    a.es-button,
    button.es-button,
    .es-button-border {
      display: block !important;
    }
    .es-m-fw,
    .es-m-fw.es-fw,
    .es-m-fw .es-button {
      display: block !important;
    }
    .es-m-il,
    .es-m-il .es-button,
    .es-social,
    .es-social td,
    .es-menu {
      display: inline-block !important;
    }
    .es-adaptive table,
    .es-left,
    .es-right {
      width: 100% !important;
    }
    .es-content table,
    .es-header table,
    .es-footer table,
    .es-content,
    .es-footer,
    .es-header {
      width: 100% !important;
      max-width: 600px !important;
    }
    .adapt-img {
      width: 100% !important;
      height: auto !important;
    }
    .es-mobile-hidden,
    .es-hidden {
      display: none !important;
    }
    .es-desk-hidden {
      width: auto !important;
      overflow: visible !important;
      float: none !important;
      max-height: inherit !important;
      line-height: inherit !important;
    }
    tr.es-desk-hidden {
      display: table-row !important;
    }
    table.es-desk-hidden {
      display: table !important;
    }
    td.es-desk-menu-hidden {
      display: table-cell !important;
    }
    .es-menu td {
      width: 1% !important;
    }
    table.es-table-not-adapt,
    .esd-block-html table {
      width: auto !important;
    }
    .h-auto {
      height: auto !important;
    }
    h2 a {
      text-align: left;
    }
  }
  @media screen and (max-width: 384px) {
    .mail-message-content {
      width: 414px !important;
    }
  }
</style>
<div
  dir="ltr"
  class="es-wrapper-color"
  lang="fr"
  style="background-color: #fafafa"
>
  <!--[if gte mso 9]>
    <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
      <v:fill type="tile" color="#fafafa"></v:fill>
    </v:background>
  <![endif]-->
  <table
    width="100%"
    cellspacing="0"
    cellpadding="0"
    class="es-wrapper"
    role="none"
    style="
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
      border-collapse: collapse;
      border-spacing: 0px;
      padding: 0;
      margin: 0;
      width: 100%;
      height: 100%;
      background-repeat: repeat;
      background-position: center top;
      background-color: #fafafa;
    "
  >
    <tbody>
      <tr style="border-collapse: collapse">
        <td valign="top" style="padding: 0; margin: 0">
          <table
            cellpadding="0"
            cellspacing="0"
            align="center"
            class="es-header"
            role="none"
            style="
              mso-table-lspace: 0pt;
              mso-table-rspace: 0pt;
              border-collapse: collapse;
              border-spacing: 0px;
              width: 100%;
              table-layout: fixed !important;
              background-color: transparent;
              background-repeat: repeat;
              background-position: center top;
            "
          >
            <tbody>
              <tr style="border-collapse: collapse">
                <td
                  align="center"
                  class="es-adaptive"
                  style="padding: 0; margin: 0"
                >
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    bgcolor="#3d5ca3"
                    align="center"
                    class="es-header-body"
                    style="
                      mso-table-lspace: 0pt;
                      mso-table-rspace: 0pt;
                      border-collapse: collapse;
                      border-spacing: 0px;
                      background-color: #3d5ca3;
                      width: 600px;
                    "
                    role="none"
                  >
                    <tbody>
                      <tr style="border-collapse: collapse">
                        <td
                          id="header_cell"
                          bgcolor="#8aa1ff"
                          align="left"
                          style="
                            margin: 0;
                            padding-top: 20px;
                            padding-right: 20px;
                            padding-bottom: 20px;
                            padding-left: 20px;
                            background-color: #8aa1ff;
                          "
                        >
                          <table
                            cellspacing="0"
                            cellpadding="0"
                            width="100%"
                            role="none"
                            style="
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                              border-collapse: collapse;
                              border-spacing: 0px;
                            "
                          >
                            <tbody>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="left"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-right: 420px;
                                    width: 140px;
                                  "
                                >
                                  <table
                                    width="100%"
                                    cellspacing="0"
                                    cellpadding="0"
                                    role="presentation"
                                    style="
                                      mso-table-lspace: 0pt;
                                      mso-table-rspace: 0pt;
                                      border-collapse: collapse;
                                      border-spacing: 0px;
                                    "
                                  >
                                    <tbody>
                                      <tr style="border-collapse: collapse">
                                        <td
                                          align="left"
                                          class="es-m-p0l es-m-txt-c"
                                          style="
                                            padding: 0;
                                            margin: 0;
                                            font-size: 0;
                                          "
                                        >
                                          <a
                                            href="{{company.website}}"
                                            target="_blank"
                                            style="
                                              mso-line-height-rule: exactly;
                                              text-decoration: none;
                                              color: #1376c8;
                                              font-size: 14px;
                                            "
                                            ><img
                                              src=""
                                              class="adapt-img"
                                              style="
                                                font-size: 16px;
                                                border: 0px;
                                                outline: none;
                                                text-decoration: none;
                                                width: 120px;
                                              "
                                              id="img_header"
                                          /></a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            cellspacing="0"
            cellpadding="0"
            align="center"
            class="es-content"
            role="none"
            style="
              mso-table-lspace: 0pt;
              mso-table-rspace: 0pt;
              border-collapse: collapse;
              border-spacing: 0px;
              width: 100%;
              table-layout: fixed !important;
            "
          >
            <tbody>
              <tr style="border-collapse: collapse">
                <td
                  bgcolor="#fafafa"
                  align="center"
                  style="padding: 0; margin: 0; background-color: #fafafa"
                >
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    bgcolor="#ffffff"
                    align="center"
                    class="es-content-body"
                    style="
                      mso-table-lspace: 0pt;
                      mso-table-rspace: 0pt;
                      border-collapse: collapse;
                      border-spacing: 0px;
                      background-color: #ffffff;
                      width: 600px;
                    "
                    role="none"
                  >
                    <tbody>
                      <tr style="border-collapse: collapse">
                        <td
                          bgcolor="transparent"
                          align="left"
                          style="
                            padding: 0;
                            margin: 0;
                            padding-right: 20px;
                            padding-left: 20px;
                            padding-top: 40px;
                            background-color: transparent;
                            background-position: left top;
                          "
                        >
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            style="
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                              border-collapse: collapse;
                              border-spacing: 0px;
                              background-position: left top;
                            "
                            role="presentation"
                          >
                            <tbody>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <h1
                                    style="
                                      margin: 0;
                                      font-family: arial, 'helvetica neue',
                                        helvetica, sans-serif;
                                      mso-line-height-rule: exactly;
                                      letter-spacing: 0;
                                      font-size: 20px;
                                      font-style: normal;
                                      font-weight: normal;
                                      line-height: 24px;
                                      color: #333333;
                                    "
                                  >
                                    <strong
                                      >Votre devis
                                      {{quote.quote_number}}</strong
                                    >
                                  </h1>
                                </td>
                              </tr>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-right: 40px;
                                    padding-left: 40px;
                                  "
                                >
                                  <p
                                    style="
                                      margin: 0;
                                      mso-line-height-rule: exactly;
                                      font-family: helvetica, 'helvetica neue',
                                        arial, verdana, sans-serif;
                                      line-height: 24px;
                                      letter-spacing: 0;
                                      color: #666666;
                                      font-size: 16px;
                                    "
                                  >
                                    Bonjour {{customer.customer_name}},
                                  </p>
                                </td>
                              </tr>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 40px;
                                    padding-right: 35px;
                                  "
                                >
                                  <p
                                    style="
                                      margin: 0;
                                      mso-line-height-rule: exactly;
                                      font-family: helvetica, 'helvetica neue',
                                        arial, verdana, sans-serif;
                                      line-height: 24px;
                                      letter-spacing: 0;
                                      color: #666666;
                                      font-size: 16px;
                                    "
                                  >
                                    Nous vous prions de trouver ci-joint le devis
                                    suite à votre demande
                                  </p>
                                </td>
                              </tr>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-right: 40px;
                                    padding-left: 40px;
                                    padding-top: 25px;
                                  "
                                >
                                  <p
                                    style="
                                      margin: 0;
                                      mso-line-height-rule: exactly;
                                      font-family: helvetica, 'helvetica neue',
                                        arial, verdana, sans-serif;
                                      line-height: 24px;
                                      letter-spacing: 0;
                                      color: #666666;
                                      font-size: 16px;
                                    "
                                  >
                                    Nous vous remercions pour votre confiance. A
                                    bientôt.
                                  </p>
                                </td>
                              </tr>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-top: 25px;
                                    padding-bottom: 25px;
                                    padding-right: 200px;
                                    padding-left: 200px;
                                    font-size: 0;
                                  "
                                >
                                  <img
                                    src=""
                                    class="adapt-img"
                                    style="
                                      font-size: 16px;
                                      border: 0px;
                                      outline: none;
                                      text-decoration: none;
                                      width: 120px;
                                    "
                                    id="img_body"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            cellspacing="0"
            cellpadding="0"
            align="center"
            class="es-footer"
            role="none"
            style="
              mso-table-lspace: 0pt;
              mso-table-rspace: 0pt;
              border-collapse: collapse;
              border-spacing: 0px;
              width: 100%;
              table-layout: fixed !important;
              background-color: transparent;
              background-repeat: repeat;
              background-position: center top;
            "
          >
            <tbody>
              <tr style="border-collapse: collapse">
                <td
                  bgcolor="#fafafa"
                  align="center"
                  style="padding: 0; margin: 0; background-color: #fafafa"
                >
                  <table
                    cellspacing="0"
                    cellpadding="0"
                    bgcolor="#ffffff"
                    align="center"
                    class="es-footer-body"
                    role="none"
                    style="
                      mso-table-lspace: 0pt;
                      mso-table-rspace: 0pt;
                      border-collapse: collapse;
                      border-spacing: 0px;
                      background-color: transparent;
                      width: 600px;
                    "
                  >
                    <tbody>
                      <tr style="border-collapse: collapse">
                        <td
                          bgcolor="#2B335D"
                          id="footer_cell"
                          align="left"
                          style="
                            padding: 0;
                            margin: 0;
                            padding-right: 20px;
                            padding-left: 20px;
                            padding-top: 10px;
                            background-position: left top;
                          "
                        >
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            role="presentation"
                            style="
                              mso-table-lspace: 0pt;
                              mso-table-rspace: 0pt;
                              border-collapse: collapse;
                              border-spacing: 0px;
                            "
                          >
                            <tbody>
                              <tr style="border-collapse: collapse">
                                <td
                                  align="center"
                                  style="
                                    padding: 0;
                                    margin: 0;
                                    padding-bottom: 5px;
                                  "
                                >
                                  <p
                                    style="
                                      margin: 0;
                                      mso-line-height-rule: exactly;
                                      font-family: helvetica, 'helvetica neue',
                                        arial, verdana, sans-serif;
                                      line-height: 21px;
                                      letter-spacing: 0;
                                      color: #ffffff;
                                      font-size: 14px;
                                    "
                                  >
                                    <br />Contacter nous: {{company.phone}} |
                                    {{company.email}}<br /><br />
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>`
